import { DetailedHTMLProps, HTMLAttributes } from 'react';
import classNames from 'classnames';

export const Card = ({
  children,
  className,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  return (
    <div className={classNames('card rounded-2xl bg-white min-w-fit p-2', className)} {...props}>
      {children}
    </div>
  );
};
